import React from 'react';
import spinner from '../assets/icons/blue-spinner.svg';
interface LoadingProps {
    text?: string;
}

const Loading: React.FC<LoadingProps> = ({ text = 'Loading...' }) => {
    return (
        <div className="fixed inset-0 bg-white bg-opacity-75 flex flex-col items-center justify-center z-50">
            <img src={spinner} alt="Loading spinner" className="w-16 h-16 animate-spin" />
            <p className="mt-4 text-lg font-semibold text-gray-700">{text}</p>
        </div>
    );
};

export default Loading;
